import classnames from 'classnames';

import style from './InformPopup.module.scss';
import '@components/mixins/commonStyles.scss';

import { Button, ButtonTheme } from '@components/Button';

import { Popup, PopupModifiers, PopupTheme } from '../Popup';
import { CommonTestAttributes } from 'chaika-test-attributes';

export interface PopupProps {
    title?: string;
    description?: (() => React.ReactNode) | string;
    withoutCloseButton?: boolean;
    withoutMargin?: boolean;
    closeText?: string;
    customWidth?: boolean;
    theme?: PopupTheme;
    modifiers?: PopupModifiers[];
    onClose(): void;
    onOutOfContentClick?(): void;
    onCrossIconClick?(): void;
    getDescription?(): React.ReactNode;
}

export const InformPopup = ({
    title,
    description,
    getDescription,
    customWidth,
    theme,
    withoutCloseButton = false,
    closeText = 'Ok',
    modifiers = [],
    onClose,
    onOutOfContentClick,
    onCrossIconClick,
    withoutMargin,
}: PopupProps) => {
    return (
        <Popup
            theme={theme}
            modifiers={modifiers}
            onOutOfContentClick={onOutOfContentClick || onClose}
            onCrossIconClick={onCrossIconClick}
        >
            <div
                className={classnames([
                    style.root,
                    withoutMargin && style.withoutMargin,
                    customWidth && style.root_customWidth,
                ])}
            >
                {title && <div className={classnames([style.title, 'font_h1'])}>{title}</div>}
                {description && (
                    <div className={classnames([style.description, 'font_h2', withoutMargin && style.withoutMargin])}>
                        {typeof description === 'string' ? description : description()}
                    </div>
                )}
                {!!getDescription && getDescription()}
                {!withoutCloseButton && (
                    <div className={style.button}>
                        <Button
                            dataTest={CommonTestAttributes.PopupCloseButton}
                            theme={ButtonTheme.Primary}
                            onClick={onClose}
                        >
                            {closeText}
                        </Button>
                    </div>
                )}
            </div>
        </Popup>
    );
};
